module.exports = __webpack_public_path__ + "img/QRCODE.5b37c7f0.png";